// wrapper around window.Beacon
function api() {
    if (__DEBUG__) {
        if (typeof window === 'undefined') throw new Error('Beacon must be called in browser context.')
        if (! window.Beacon) throw new Error('Beacon is not installed.')
    }
    window.Beacon.apply(window.Beacon, arguments)
}

module.exports = api
